export default "__VITE_ASSET__Def6jkQg__"